import React, { Component } from 'react';
import './sec2.css';

function Sec2() {
  return (
    <section id="overview" className="overview-section">

      <div className="overview-inner">

      <div className="overview-left">
  <p className="overview-label">Who Was He</p>
  <h2 className="overview-title">
    The Ultimate<br />
    <span className="title-italic">Renaissance Man</span>
  </h2>
  <p className="overview-subtitle">Florence · Milan · Rome · Amboise</p>
</div>

        <div className="overview-grid">

          <div className="overview-card">
            <span className="card-number">01</span>
            <h3>Painter</h3>
            <p>Creator of the Mona Lisa and The Last Supper — two of the most recognised paintings in history.</p>
          </div>

          <div className="overview-card">
            <span className="card-number">02</span>
            <h3>Inventor</h3>
            <p>Designed early concepts for the helicopter, solar power, a calculator, and plate tectonics — centuries ahead of his time.</p>
          </div>

          <div className="overview-card">
            <span className="card-number">03</span>
            <h3>Anatomist</h3>
            <p>Dissected over 30 human corpses, producing the most accurate anatomical drawings of his era.</p>
          </div>

          <div className="overview-card">
            <span className="card-number">04</span>
            <h3>Scientist</h3>
            <p>His notebooks contain over 13,000 pages of observations, sketches, and theories across every field of knowledge.</p>
          </div>

        </div>

      </div>

      <span className="overview-watermark">VINCI</span>

    </section>
  );
}

export default Sec2;